import React from 'react';
import TemplatePage from "../template_page/template_page";
import {Page} from "../../model/page";
import CourseDetail from "../../luiss_components/c25b_course_detail/course_detail";

export interface CoursePageAttributes {
    course_type?: string;
    course_attribute?: string;
    label_dipartimento?: string;
    color_dipartimento?: string;
}

export interface CoursePageData extends Page, CoursePageAttributes {}

class CoursePage extends TemplatePage<CoursePageData> {

    beforeRightComponentsList(page: CoursePageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {

        let courseData = {
            course_type: page.course_type,
            course_attribute: page.course_attribute
        };

        return (
            <CourseDetail language={this.props.language} layoutColumns={this.props.layoutColumns} data={courseData} />
        );
    }
}

export default CoursePage;